'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('packagesService', [
      '$http',
      '$q',
      'proxyprefix',
      'inomialService',
      'basepackid',
      'skinnyPackIds',
      'ultimatePackId',
      function(
        $http,
        $q,
        proxyprefix,
        inomialService,
        basepackid,
        skinnyPackIds,
        ultimatePackId,
      ) {
        var trialPackIds = [
          '5b4a7e9b-7aa1-4238-8815-a6c5f6934610', // 10AA Trial Retail Test
          'd90604ba-7bb9-4589-9728-e99c6c57c4e0', // 10AA Trial Retail
        ];

        var hiddenPackIds = [
          '41f87379-68ef-4d1e-a483-14e6ea940877', // 10AA Retail
          '1a17e1f4-3584-49f5-bb7f-08f1b7286b3f', // 10AA Retail Test
        ].concat(trialPackIds);

        function getTrialPackIds() {
          return trialPackIds;
        }

        /** Get list of available packages
         * @returns {Promise<Array<Object>>} List of package dictionaries.
         **/
        function getAvailablePackages() {
          return $http.post(`${proxyprefix}/getAvailablePackages`)
            .then(
              response => {
                const data = response.data;
                if (data.__meta__.error) {
                  return $q.reject(data.__meta__.error);
                }
                delete data.__meta__;
                const packageList = data.FetchPackage
                  .filter(
                    pack => {
                      return hiddenPackIds.indexOf(pack.FetchPackageId) === -1;
                    });
                setPacksAttributes(packageList);
                return packageList;
              });
        }

        /** Add additional metadata to pack lists.
         * @param {Array<Object>} packList Packages list.
         * @returns {undefined}
         **/
        function setPacksAttributes(
          packList,
        ) {
        /* -------------SET BASE PACK FLAG ------------------- */
          const basePack = packList.find(
            pack => {
              return pack.FetchPackageId == basepackid;
            });

          if (basePack) {
            basePack.isBasePack = true;
          }

          /* -------------SET SKINNY PACK FLAG ------------------- */
          skinnyPackIds.forEach(
            skinnyItem => {
              var skinny = packList.find(
                pack => {
                  return pack.FetchPackageId === skinnyItem.id;
                });

            if (skinny) {
              skinny.isSkinnyPack = true;
            }
          });

          /* -------------SET Ultimate PACK FLAG ------------------- */
          const ultiPack = packList.find(
            pack => {
              return pack.FetchPackageId === ultimatePackId;
            });

          if (ultiPack) {
            ultiPack.isUltimatePack = true;
          }
        }

        /** Retrieve channel mappings for packages
         * @returns {Promise<Object<String, Object>>} Dictionary of pack ids as key mapped to definitions
         * @example Definition keys: name {String}, channels {Array<String>}
         **/
        function getPackageDetails() {
          return $http.get(`${proxyprefix}/packages_description`)
            .then(
              response => {
                const data = response.data;
                if (data.__meta__.error) {
                  return $q.reject(data.__meta__.error);
                }
                delete data.__meta__;
                return data;
              });
        }

        function getAvailablePacksWithDetails() {
          var avail_packs = [];
          return getAvailablePackages()
            .then(
              packs => {
                avail_packs = packs;
              })
            .then(getPackageDetails)
            .then(
              packs_details => {
                avail_packs.forEach(
                  pack => {
                    if (packs_details[pack.FetchPackageId]) {
                      pack.channels = packs_details[pack.FetchPackageId].channels;
                    }
                  },
                );
              })
            .then(() => {
              return avail_packs;
            });
        }

        /**
         * Returns a list of packages that provide a given channel id.
         * @param {String} channelId The channel id to query.
         * @returns {Array String} A list of Fetch package ids.
         **/
        function getPackagesForChannel(
          channelId,
        ) {
          return getAvailablePacksWithDetails()
            .then(
              packages => {
                return packages.filter(
                  pack => {
                    if (angular.isUndefined(pack.channels)) {
                      return false;
                    }
                    return pack.channels.indexOf(channelId) !== -1;
                  });
              })
            .then(
              providerPackages => {
                return providerPackages
                  .map(
                    pack => {
                      return pack.FetchPackageId;
                    });
              });
        }

        /**
         * Returns a list of packages that provide any of the given channels id.
         * @param {String} channelId The channel id to query.
         *
         * @returns {Array String} A list of Fetch package ids.
         **/
        function getPackagesForChannels(
          channelIds,
        ) {
          return $q.all(
            channelIds
              .map(getPackagesForChannel)
          )
            .then(results => {
              return results.reduce(
                (
                  packs,
                  result,
                ) => {
                  return [
                    ...packs,
                    ...result,
                  ];
                },
                [],
              );
            });
        }

        /**
         * Returns whether or not which packs user is subscribed to.
         * @param {Array<String>} packIds Pack Ids
         * @returns {Promise Array Boolean} List of booleans for each pack and whether it is subscribed or not.
         **/
        function userSubscribedToPacks(
          packIds,
        ) {
          return inomialService.update()
            .then(
              result => {
                return result.CurrentPlan.Option;
              })
            .then(
              packages => {
                return packIds.map(
                  packId => {
                    var pack = packages.find(
                      subscribedPackage => {
                        return subscribedPackage.FetchPackageId === packId;
                      });
                    return pack !== undefined;
                  });
              });
        }

        return {
          getAvailablePackages: getAvailablePackages,
          getPackageDetails: getPackageDetails,
          getAvailablePacksWithDetails: getAvailablePacksWithDetails,
          getTrialPackIds: getTrialPackIds,
          getPackagesForChannel: getPackagesForChannel,
          getPackagesForChannels: getPackagesForChannels,
          userSubscribedToPacks: userSubscribedToPacks
        };
      }]);
})(angular);
